export const ACCEPTED_MIME_TYPES = {
  'application/pdf': 'pdf',
  'image/jpeg': 'jpg',
  'image/png': 'png',
  'image/gif': 'gif',
  'text/plain': 'txt',
} as const;

export const MAX_FILE_SIZE = 32 * 1000000;
